module.exports = __webpack_public_path__ + "static/media/business7.7789c97a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/business7.png
// module id = 87
// module chunks = 0